<template>
  <b-card>
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="O que sera cobrado?"
              label-for="charge"
            >
              <validation-provider
                #default="{ errors }"
                name="O que sera cobrado"
                rules="required"
              >
                <b-form-input
                  id="charge"
                  v-model="req.product.name"
                  placeholder="O que sera cobrado?"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group
              label="Valor total"
              label-for="value"
            >
              <validation-provider
                #default="{ errors }"
                name="Valor total"
                rules="required|value"
              >
                <b-form-input
                  id="value"
                  v-model="value"
                  v-money
                  :state="errors.length > 0 ? false : null"
                  placeholder="Valor total"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="Quantidade"
              label-for="count"
            >
              <validation-provider
                #default="{ errors }"
                name="Quantidade"
                rules="required|integer"
              >
                <b-form-input
                  id="count"
                  v-model="req.product.amount"
                  v-mask="'###'"
                  placeholder="Quantidade"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="Data de Vencimento"
              label-for="v-DueDate"
            >
              <validation-provider
                #default="{ errors }"
                name="Data de Vencimento"
                rules="required|dueDate"
              >
                <b-form-input
                  id="v-born"
                  v-model="req.payment.expiration_date"
                  placeholder="Data de Vencimento"
                  type="date"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Nome do pagador"
              label-for="charge"
            >
              <validation-provider
                #default="{ errors }"
                name="Nome do Pagador"
                rules="required"
              >
                <b-form-input
                  id="charge"
                  v-model="req.customer.name"
                  :readonly="readOnlyCustomer"
                  placeholder="Nome do pagador"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group
              label-for="id"
              label="Documento"
            >
              <validation-provider
                #default="{ errors }"
                rules="required|document"
                name="Documento"
              >
                <b-form-input
                  id="id"
                  v-model="req.customer.tax_id"
                  v-mask="[
                    '###.###.###-##',
                    '##.###.###/####-##',
                    '##.###.###',
                  ]"
                  :readonly="readOnlyCustomer"
                  placeholder="CPF/CNPJ"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label-for="payerEmail"
              label="E-mail do pagador"
            >
              <validation-provider
                #default="{ errors }"
                name="Email"
                rules="required|email"
              >
                <b-form-input
                  id="payerEmail"
                  v-model="req.customer.email"
                  :readonly="readOnlyCustomer"
                  :state="errors.length > 0 ? false : null"
                  type="email"
                  placeholder="E-mail do pagador"
                />

                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="3">
            <b-form-group
              label-for="phone"
              label="Telefone"
            >
              <validation-provider
                #default="{ errors }"
                name="Telefone"
                rules="required|phone"
              >
                <b-form-input
                  id="phone"
                  v-model="req.customer.phone"
                  v-mask="['(##) ####-####', '(##) #####-####']"
                  :readonly="readOnlyCustomer"
                  placeholder="Telefone"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col
            sm="12"
            lg="3"
            md="12"
            offset-xl="0"
          >
            <b-form-group
              label="País"
              label-for="v-country"
            >
              <validation-provider
                #default="{ errors }"
                name="País"
                rules="required"
              >
                <b-form-select
                  id="v-country"
                  v-model="req.billing.country"
                  :options="optionsCountries"
                  :state="errors.length > 0 ? false : null"
                  @change="checkCountry()"
                >
                  <template v-slot:first>
                    <b-form-select-option value="BR">
                      Brasil
                    </b-form-select-option>
                  </template>
                </b-form-select>
                <small class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            lg="3"
            md="12"
            offset-xl="0"
          >
            <b-form-group
              label="CEP"
              label-for="v-cep"
            >
              <validation-provider
                #default="{ errors }"
                name="CEP"
                :rules="`required|${req.billing.country == 'BR' ? `cep: ${req.billing.state}` : ''}`"
              >
                <b-form-input
                  id="v-cep"
                  v-model="req.billing.postal_code"
                  v-mask="req.billing.country === 'BR' ? '#####-###' : '##########'"
                  placeholder="CEP"
                  :state="errors.length > 0 ? false : null"
                  @change="req.billing.country==='BR'&&searchPostalCode()"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            lg="3"
            md="12"
            offset-xl="0"
          >
            <b-form-group
              label="Estado"
              label-for="v-state"
            >
              <validation-provider
                #default="{ errors }"
                name="Estado"
                rules="required"
              >
                <b-form-input
                  id="v-state"
                  v-model="req.billing.state"
                  placeholder="Estado"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            lg="3"
            md="12"
            offset-xl="0"
          >
            <b-form-group
              label="Cidade"
              label-for="v-city"
            >
              <validation-provider
                #default="{ errors }"
                name="Cidade"
                rules="required"
              >
                <b-form-input
                  id="v-city"
                  v-model="req.billing.city"
                  placeholder="Cidade"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col
            sm="12"
            md="12"
            lg="6"
            offset-xl="0"
          >
            <b-form-group
              label="Endereço"
              label-for="v-address"
            >
              <validation-provider
                #default="{ errors }"
                name="Endereço"
                rules="required"
              >
                <b-form-input
                  id="v-address"
                  v-model="req.billing.address"
                  placeholder="Endereço"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="12"
            lg="6"
            offset-xl="0"
          >
            <b-form-group
              label="Bairro"
              label-for="v-district"
            >
              <validation-provider
                #default="{ errors }"
                name="Bairro"
                rules="required"
              >
                <b-form-input
                  id="v-district"
                  v-model="req.billing.district"
                  placeholder="Bairro"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
            lg="3"
            offset-xl="0"
          >
            <b-form-group
              label="Número"
              label-for="v-number"
            >
              <validation-provider
                #default="{ errors }"
                name="Número"
                rules="required"
              >
                <b-form-input
                  id="v-number"
                  v-model="req.billing.number"
                  type="number"
                  placeholder="Número"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            sm="12"
            md="6"
            lg="3"
          >
            <b-form-group
              label="Complemento"
              label-for="v-complemento"
            >
              <b-input-group class="input-group-merge">
                <b-form-input
                  id="v-complemento"
                  v-model="req.billing.complement"
                  placeholder="Complemento"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <div>
          <b-button
            class="button-generate"
            variant="info"
            @click="validationForm()"
          >
            Gerar
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BFormSelect,
  BFormSelectOption,
  BForm,
  BButton,
  BCard,
} from 'bootstrap-vue'
import {
  ValidationProvider,
  ValidationObserver,
} from 'vee-validate'
import {
  required,
  email,
} from '@validations'

import Ripple from 'vue-ripple-directive'

import { generateLink } from '@/service/transaction-generator/transaction-generator'
import { getPostalCode } from '@/service/others/others'

import { callLoading } from '@/service/utilities/utilities'

const countries = require('@/information/countries').default

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BInputGroup,
    BFormSelectOption,
    BForm,
    BButton,
    BCard,
  },
  directives: {
    Ripple,
  },
  props: {
    customer: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      required,
      email,
      value: 0.01,
      readOnlyCustomer: false,
      id: null,
      optionsCountries: countries,
      req: {
        customer: {
          name: null,
          email: null,
          tax_id: null,
          phone: null,
        },
        product: {
          name: null,
          amount: null,
        },
        payment: {
          value: 0,
          expiration_date: null,
          instructions: null,
        },
        billing: {
          name: null,
          address: null,
          number: null,
          complement: null,
          city: null,
          district: null,
          state: null,
          postal_code: null,
          country: 'BR',
          phone: null,
          email: null,
        },
      },
    }
  },
  watch: {
    // eslint-disable-next-line func-names
    'req.billing.country': function (country) {
      if (country === 'BR') { this.searchPostalCode() }
    },
  },
  created() {
    this.verifyObject()
  },
  methods: {
    async verifyObject() {
      if (this.customer.isTrue) {
        this.readOnlyCustomer = true
        this.req.customer.name = this.customer.name
        this.req.customer.email = this.customer.email
        this.req.customer.phone = this.customer.phone
        this.req.customer.tax_id = this.customer.tax_id
      }
    },
    error() {
      this.$swal({
        title: 'Erro na Criação do Boleto!',
        icon: 'error',
        timer: 2000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) { (this.createLink()) }
      })
    },

    async searchPostalCode() {
      const response = await getPostalCode(this.req.billing.postal_code)
      const {
        address, city, district, state,
      } = response.data

      this.req.billing.state = state
      this.req.billing.city = city
      this.req.billing.address = address
      this.req.billing.district = district
    },
    async createLink() {
      callLoading(true)
      const merchantId = Number(sessionStorage.getItem('veripagID'))
      if (!Number.isInteger(merchantId) || merchantId <= 0) {
        callLoading(false)
        this.$router.push({ name: 'select-merchant' })
        return
      }

      // remove symbols from postal code
      this.req.billing.postal_code = this.req.billing.postal_code.replace('-', '')

      this.req.billing.name = this.req.customer.name
      this.req.billing.email = this.req.customer.email

      this.req.merchant_id = merchantId

      // transform value from string to float

      this.req.payment.value = +this.value.replace(/[R$.]/g, '').replace(',', '.')

      try {
        // call generatelink method
        const response = await generateLink('bankslip', this.req)
        const { status } = response
        if (status === 200) {
          this.$router.push({
            path: `/boleto/confirmado/${response.data.bankslip.bar_code}`,
            query: {
              link: response.data.bankslip,
            },
          })
        } else {
          this.error()
        }
      } catch {
        this.error()
      } finally {
        callLoading(false)
      }
    },
  },

}
</script>

<style scoped lang="scss">
  @import "@core/scss/base/pages/page-link-generator.scss";
</style>
